import { useGlobal } from '@/utils/useGlobal';
import Car from 'elem/SVGIcon/PowerBackup/Car';
import Interest from 'elem/SVGIcon/PowerBackup/Interest';
import FindIcon from 'elem/SVGIcon/PowerBackup/Find';
import Service from 'elem/SVGIcon/PowerBackup/Service';
import css from './index.module.scss';
import QuoteWin from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteWin';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';

export default function G() {
    const { useLang, useState, Link, gtm, useRouter } = useGlobal();
    const { t } = useLang('G');
    const [openQuoteFlag, setOpenQuoteFlag] = useState(false);
    const { locale = 'us' } = useRouter();
    let items = [
        {
            icon: <Car />,
            title: t('secG_wrap_item1_title'),
            desc: t('secG_wrap_item1_desc'),
        },
        {
            icon: <Interest />,
            title: t('secG_wrap_item2_title'),
            desc: t('secG_wrap_item2_desc'),
        },
        {
            icon: <FindIcon />,
            title: t('secG_wrap_item3_title'),
            desc: t('secG_wrap_item3_desc'),
            link: {
                text: t('secG_store_btn'),
                url: '/where-to-buy',
            },
        },
        {
            icon: <Service />,
            title: t('secG_wrap_item4_title'),
            desc: (
                <span
                    className="desc phone"
                    onClick={() => {
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'product_detail_page',
                            list_name: "We're Here For You",
                            button_name: '+1 (800)-368-8604',
                        });
                        window.open(`mailto:${t('secG_service_number')}`, '_blank'); // 手动打开邮件客户端
                    }}
                >
                    <span className="phone-service">
                        <Service className="mini-service" />
                        {t('secG_service_number')}
                    </span>
                    <span className="additionalDesc">&ensp;{t('secG_wrap_item4_desc')}</span>
                </span>
            ),
            btn: {
                text: t('secG_wrap_item4_btn_text'),
                callback: () => {
                    setOpenQuoteFlag(true);
                },
            },
        },
    ];
    if (locale === 'ca') {
        items = [
            {
                icon: <Interest />,
                title: t('secG_wrap_item2_title'),
                desc: t('secG_wrap_item2_desc'),
            },
            {
                icon: <FindIcon />,
                title: t('secG_wrap_item3_title'),
                desc: t('secG_wrap_item3_desc'),
                link: {
                    text: t('secG_store_btn'),
                    url: '/ca/where-to-buy',
                },
            },
            {
                icon: <Service />,
                title: t('secG_wrap_item4_title'),
                desc: (
                    <span
                        className="desc phone"
                        onClick={() => {
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'product_detail_page',
                                list_name: "We're Here For You",
                                button_name: '+1(800)-368-8604 (Mon-Fri 9-7, EST)',
                            });
                            window.open(`mailto:${t('secG_service_number')}`, '_blank'); // 手动打开邮件客户端
                        }}
                    >
                        <span className="phone-service">
                            <Service className="mini-service" />
                            {t('secG_service_number')}
                        </span>
                        <span className="additionalDesc">&ensp;{t('secG_wrap_item4_desc')}</span>
                    </span>
                ),
                btn: {
                    text: t('secG_wrap_item4_btn_text'),
                    callback: () => {
                        setOpenQuoteFlag(true);
                    },
                },
            },
        ];
    }
    const quoteCallback = (type: string) => {
        if (type === 'close') {
            setOpenQuoteFlag(false);
        }
    };

    return (
        <div
            id="power-preparedness-G"
            className={`power-preparedness-G ${css['power-preparedness-G']} GtmModuleData-section`}
            data-section-id={'powerPreparedness-G'}
            data-section-title={t('secG_title')}
        >
            <div className="page-space"></div>
            <EcoSectionCommon title={t('secG_title')} />
            <div className="wrapper page-layout">
                {items.map((item, index) => (
                    <div className="wrapper-item" key={index}>
                        <div className="icon">{item.icon}</div>
                        <div className="item-title">{item.title}</div>
                        <div className="desc">{item.desc}</div>
                        {item.link && (
                            <span
                                className="go-now"
                                onClick={() => {
                                    gtm.push({
                                        event: 'uaEvent',
                                        event_name: 'product_detail_page',
                                        list_name: "We're Here For You",
                                        button_name: item.link.text,
                                    });
                                    window.open(item.link.url, '_blank');
                                }}
                            >
                                {item.link.text}
                            </span>
                        )}
                        {/* {item.additionalDesc && <div className="desc">{item.additionalDesc}</div>} */}
                        {item.btn && (
                            <span
                                className="go-now"
                                onClick={() => {
                                    item.btn.callback();
                                    gtm.push({
                                        event: 'uaEvent',
                                        event_name: 'click_get_a_quote',
                                        product_name: item.btn.text,
                                        position: "We're Here For You",
                                        option_name: 'Free Quote',
                                    });
                                }}
                            >
                                {item.btn.text}
                            </span>
                        )}
                    </div>
                ))}
            </div>
            <div className="page-space"></div>
            {openQuoteFlag && <QuoteWin callback={quoteCallback} />}
        </div>
    );
}
